export default __webpack_public_path__ + "static/media/Polos de Tecnologia.15251781.png";